module.exports = __webpack_public_path__ + "static/media/startup.24843f05.svg";